export default __webpack_public_path__ + "static/media/HOSTSDISC_Dashboard.c9c06099.svg";